import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteQuotation(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/quotations/${id}`,
        method: "DELETE",
    });
}
